import React, { useState, useEffect, useRef } from 'react';
import {
    TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, Row, Col,
    InputGroupText, Input, InputGroup, InputGroupAddon, FormGroup
} from 'reactstrap';
import classnames from 'classnames';
import Users from '../Users/Users';
import Roles from './Roles';
import RoleUserCard from './RoleUserCard';
import UserCard from './UserCard';
import { store } from '../../Helper';
import Lookups from './Lookups';

function Administration(props) {
    const [activeTab, setActiveTab] = useState('roles');

    const [roles, setRoles] = useState([]);
    const [isLoadingRoles, setIsLoadingRoles] = useState(true);

    const [roleId, setRoleId] = useState(1);
    const [role, setRole] = useState(null);
    const [isLoadingRole, setIsLoadingRole] = useState(true);

    useEffect(() => {
        fetchRoles();
    }, []);

    useEffect(() => {
        fetchRole();
    }, [roleId]);

    const fetchRoles = async () => {
        setIsLoadingRoles(true);

        setRoles(store.roles);

        setIsLoadingRoles(false);
    };

    const fetchRole = async () => {
        setIsLoadingRole(true);

        setRole(store.roles.find(r => r.id === roleId));

        setIsLoadingRole(false);
    };

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const removeUserFromRole = (userId) => {
        console.log(`Removing user (${userId}) from role: ${role.name}`);
    };

    const addUserToRole = () => {
        console.log('Adding user to role: ' + role.name);
        //setRole({ ...role, users: [{ id: getNewRoleUserId(), email: null }, ...role.users] });
    }

    const saveUserRole = (email) => {
        console.log(`Adding user (${email}) to role (${roleId})...`);
    };

    return (
        <div id="administration">
            <Row className="header-row">
                <Col>
                    <h1>Administration</h1>
                </Col>
            </Row>
            <Row className="tabs-row">
                <Col>
                    <Nav tabs>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === 'roles' })}
                                onClick={() => { toggle('roles'); }}>
                                Roles
                            </NavLink>
                        </NavItem>
                        {/*<NavItem>*/}
                        {/*    <NavLink*/}
                        {/*        className={classnames({ active: activeTab === 'users' })}*/}
                        {/*        onClick={() => { toggle('users'); }}>*/}
                        {/*        Users*/}
                        {/*    </NavLink>*/}
                        {/*</NavItem>*/}
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === 'lookups' })}
                                onClick={() => { toggle('lookups'); }}>
                                DANR Programs
                            </NavLink>
                        </NavItem>
                    </Nav>
                </Col>
            </Row>
            <Row className="tab-content-row">
                <Col>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="roles">
                            <Roles/>
                        </TabPane>
                        {/*<TabPane tabId="users">*/}
                        {/*    <Users/>*/}
                        {/*</TabPane>*/}
                        <TabPane tabId="lookups">
                            <Lookups/>
                        </TabPane>
                    </TabContent>
                </Col>
            </Row>
        </div>
    );
}

export default Administration;